//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../no/Tooling.js";
let d=[[[0,"ConnectableProxyObjectType",1,0],[0,"CreationMode",1,0],[0,"EngObjectType",0,"AME.SelectionEngineeringObjectDefinitionBuilder",0],[0,"PortClassId",1,0],[0,"PortName",1,0],[0,"PortType",1,0],[0,"ReuseLibraryItem",0,"Tooling.SelectReuseLibraryItemBuilder",0]],[[["portDirection"],"SetPortDirection",{},1,0],[["portCardinality"],"SetPortCardinality",{},1,0]],[]];
SPLM.AME.PortBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.PortBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.PortBuilder.Type = Object.freeze({
    "All" : "All", "Caller" : "Caller", "Operand" : "Operand", "Method" : "Method", "Block" : "Block"});

SPLM.AME.PortBuilder.CreationModeType = Object.freeze({
    "New" : "New", "Library" : "Library"});

SPLM.AME.PortBuilder.ConnectableAttrProxyObjectType = Object.freeze({
    "All" : "All", "Library" : "Library", "Tag" : "Tag"});

export default SPLM;